<template>
  <div class="access-denied">
    <div class="card">
      <div class="emoji">😢</div>
      <h1>Access Denied!</h1>
      <p>Sorry, you don’t have permission to access this page.</p>
      <router-link to="/" class="btn">Go Home</router-link>
    </div>
  </div>
</template>

<script setup></script>

<style scoped>
.access-denied {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background: linear-gradient(135deg, #ff758c, #ff7eb3);
  padding: 20px;
}

.card {
  background: rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(10px);
  border-radius: 20px;
  padding: 40px;
  text-align: center;
  box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.2);
  max-width: 400px;
  width: 100%;
}

.emoji {
  font-size: 60px;
  animation: cryAnimation 1.5s infinite alternate;
}

@keyframes cryAnimation {
  0% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(10px);
  }
}

/* Text Styling */
h1 {
  font-size: 26px;
  margin: 10px 0;
  color: white;
}

p {
  font-size: 16px;
  color: white;
  margin-bottom: 20px;
}

.btn {
  display: inline-block;
  padding: 10px 20px;
  font-size: 16px;
  font-weight: bold;
  color: #ff758c;
  background: white;
  border-radius: 50px;
  text-decoration: none;
  transition: 0.3s;
}

.btn:hover {
  background: #ffebee;
}
</style>
